// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__6KVaw","hello":"Header_hello__3lXKK","sag":"Header_sag__aORuH","dev":"Header_dev__+mS4S","me":"Header_me__fPecB"};